<template>
  <div class="shop bp-page">
    <template v-if="show_page">
      <PageHeader />
      <div class="bp-page__content">
        <vue-scroll
          ref="scroll"
          class="bp-page__scroll"
          :ops="scroll_options"
          @handle-scroll="handleScroll"
        >
          <ShopList @stopBoxesScroll="stopBoxesScroll" />
        </vue-scroll>
      </div>
      <template v-if="isDesktop">
        <div
          :key="`prev_${scroll}`"
          class="bp-page__arrow bp-page__arrow--prev"
          :class="{ 'type--disabled': isArrowDisabled(0) }"
        >
          <button @click="scrollPage('left')">
            <i class="icon icon-arrow-big"></i>
          </button>
        </div>
        <div
          :key="`next_${scroll}`"
          class="bp-page__arrow bp-page__arrow--next"
          :class="{ 'type--disabled': isArrowDisabled(1) }"
        >
          <button @click="scrollPage('right')">
            <i class="icon icon-arrow-big"></i>
          </button>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import "@/assets/shop/styles/shop.styl";
import ShopList from "./blocks/ShopList";
import PageHeader from "@/components/Common/PageHeader";
import ScrollArrowMixin from "@/components/Common/ScrollArrowMixin";
import WindowSizeMixin from "@/components/Common/WindowSizeMixin";

export default {
  name: "Shop",
  components: {
    ShopList,
    PageHeader,
  },
  mixins: [ScrollArrowMixin, WindowSizeMixin],

  data() {
    return {
      show_page: false,
      active_box_id: 0,
      scroll_distance: 480,
      scroll_options: {
        vuescroll: {
          wheelDirectionReverse: true,
        },
        rail: {
          background: "rgba(255, 255, 255, .15)",
          opacity: 1,
          size: "20px",
          specifyBorderRadius: "0px",
        },
        bar: {
          background: "#DCDCDC",
          opacity: 1,
          size: "20px",
          specifyBorderRadius: "0px",
          keepShow: true,
        },
      },
    };
  },

  mounted() {
    this.$store.dispatch("shop/getShopList").then(() => {
      this.show_page = true;
    });
  },

  methods: {
    stopBoxesScroll() {
      this.$refs["scroll"].nativeStop();
    },
  },
};
</script>
